import styled from "styled-components/macro";

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 1em 0 0 0;
  width: 100%;
`;
